/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-10 17:27:55
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-23 17:18:03
 * @FilePath: /unifyxp-v2-store-portal/src/config/routerConfig/salesChannelEditor/salesChannelEditor.ts
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */
import { EnumPageType } from 'src/types/common';

import {
  SalesChannelAppearanceEditorPage,
  SalesChannelContentPageEditorPage,
  SalesChannelEditor404Page,
  SalesChannelEditorAllProductPage,
  SalesChannelEditorAnimation,
  SalesChannelEditorButton,
  SalesChannelEditorContentPageList,
  SalesChannelEditorFooter,
  SalesChannelEditorHeader,
  SalesChannelEditorHomepage,
  SalesChannelEditorMegaMenu,
  SalesChannelEditorNavigation,
  SalesChannelEditorProductSearch,
  SalesChannelEditorProfilePage,
  SalesChannelEditorPromotion,
  //SalesChannelEditorMaintenancePage,
  SalesChannelEditorShoppingCartPage,
  SalesChannelEditorTabbar,
  SalesChannelEditorText,
} from '@/src/pages';
import { IRouteSubRoutes } from 'src/types/router';
import { contentDetailPage } from 'src/tools/permissions/salesChannelPermissions';
import { EPermissionSource } from 'src/types/common/resources';
import { salesChannelRoutes } from 'src/tools/urlMap';

const multipleLanguageProps = (type, reduxAccessKeys) => ({
  type,
  uuidKey: 'contentUuid',
  reduxAccessKeys,
});
const listRoutes: IRouteSubRoutes[] = [
  {
    exact: true,
    path: salesChannelRoutes.salesChannelEditorHomepage, // '/salesChannel/editor/content/homepage/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorHomepage,
    isPrivate: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentHomePage, [
      '/salesChannel/editor/content/homepage/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    exact: true,
    path: salesChannelRoutes.salesChannelEditor404Page, //'/salesChannel/editor/content/404/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditor404Page,
    isPrivate: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.Content404Page, [
      '/salesChannel/editor/content/404/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },

  {
    path: salesChannelRoutes.salesChannelEditorProductSearch, //'/salesChannel/editor/content/productSearch/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorProductSearch,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentSearchPage,
      [
        '/salesChannel/editor/content/productSearch/:saleChannelUuid/:contentUuid',
      ],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    path: salesChannelRoutes.salesChannelEditorContentPageList, //'/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorContentPageList,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentPage, [
      '/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid',
      '/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid/:contentPageUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    path: salesChannelRoutes.salesChannelContentPageEditorPage, // '/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid/:contentPageUuid',
    component: SalesChannelContentPageEditorPage,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentPage, [
      '/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid',
      '/salesChannel/editor/content/contentPage/:saleChannelUuid/:contentUuid/:contentPageUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },

  {
    path: salesChannelRoutes.salesChannelEditorTabbar, //'/salesChannel/editor/content/tabbar/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorTabbar,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentTabBar, [
      '/salesChannel/editor/content/tabbar/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    path: salesChannelRoutes.salesChannelEditorShoppingCartPage, //'/salesChannel/editor/content/shoppingCart/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorShoppingCartPage,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentShoppingCartPage,
      [
        '/salesChannel/editor/content/shoppingCart/:saleChannelUuid/:contentUuid',
      ],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    path: salesChannelRoutes.salesChannelEditorPromotion, // '/salesChannel/editor/content/promotion/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorPromotion,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentPromotionPage,
      ['/salesChannel/editor/content/promotion/:saleChannelUuid/:contentUuid'],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
    //permissionGroup: [EnumPermissions.CANTEST],
  },
  {
    path: salesChannelRoutes.salesChannelEditorProfilePage, //'/salesChannel/editor/content/profilepage/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorProfilePage,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentProfilePage,
      [
        '/salesChannel/editor/content/profilepage/:saleChannelUuid/:contentUuid',
      ],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorAllProductPage, //'/salesChannel/editor/content/allProductsPage/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorAllProductPage,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentAllProductsPage,
      [
        '/salesChannel/editor/content/allProductsPage/:saleChannelUuid/:contentUuid',
      ],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelAppearanceEditorPage, //'/salesChannel/editor/content/appearance/:saleChannelUuid/:contentUuid',
    component: SalesChannelAppearanceEditorPage,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentAppearancePage,
      ['/salesChannel/editor/content/appearance/:saleChannelUuid/:contentUuid'],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorNavigation, //'/salesChannel/editor/content/navigation/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorNavigation,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentNavigation,
      ['/salesChannel/editor/content/navigation/:saleChannelUuid/:contentUuid'],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorHeader, //'/salesChannel/editor/content/header/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorHeader,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentHeader, [
      '/salesChannel/editor/content/header/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorFooter, //'/salesChannel/editor/content/footer/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorFooter,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentFooter, [
      '/salesChannel/editor/content/footer/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorMegaMenu, //'/salesChannel/editor/content/megaMenu/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorMegaMenu,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentMegaMenu, [
      '/salesChannel/editor/content/megaMenu/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorAnimation, //'/salesChannel/editor/content/animation/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorAnimation,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(
      EnumPageType.ContentAnimation,
      ['/salesChannel/editor/content/animation/:saleChannelUuid/:contentUuid'],
    ),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorButton, //'/salesChannel/editor/content/button/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorButton,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentButton, [
      '/salesChannel/editor/content/button/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
  {
    path: salesChannelRoutes.salesChannelEditorText, //'/salesChannel/editor/content/text/:saleChannelUuid/:contentUuid',
    component: SalesChannelEditorText,
    isPrivate: true,
    exact: true,
    multipleLanguageProps: multipleLanguageProps(EnumPageType.ContentText, [
      '/salesChannel/editor/content/text/:saleChannelUuid/:contentUuid',
    ]),
    permissionGroupGenerate: contentDetailPage,
    source: EPermissionSource.salesChannel,
  },
];
export default listRoutes;
